var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input",attrs:{"type":"date","disabled":_vm.disabled,"max":_vm.computedMaxDate,"min":_vm.computedMinDate},domProps:{"value":_vm.modelValue},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }